/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ConflictResolution = {
    Skip: 'Skip',
    Upsert: 'Upsert',
    ErrorOnConflict: 'ErrorOnConflict'
} as const;
export type ConflictResolution = typeof ConflictResolution[keyof typeof ConflictResolution];


export function instanceOfConflictResolution(value: any): boolean {
    for (const key in ConflictResolution) {
        if (Object.prototype.hasOwnProperty.call(ConflictResolution, key)) {
            if (ConflictResolution[key as keyof typeof ConflictResolution] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConflictResolutionFromJSON(json: any): ConflictResolution {
    return ConflictResolutionFromJSONTyped(json, false);
}

export function ConflictResolutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConflictResolution {
    return json as ConflictResolution;
}

export function ConflictResolutionToJSON(value?: ConflictResolution | null): any {
    return value as any;
}

export function ConflictResolutionToJSONTyped(value: any, ignoreDiscriminator: boolean): ConflictResolution {
    return value as ConflictResolution;
}

